/*
  Size guide dialog.

  Uses the native <dialog> element, so focus trapping, Escape-to-close and the
  backdrop are handled by the browser rather than reimplemented. Falls back to
  a plain open attribute where showModal is unavailable.
*/
(function () {
  'use strict';

  function dialogFor(el) {
    var root = el.closest('.ppdp, form, section, body');
    return (root || document).querySelector('[data-sizeguide]');
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-sizeguide-open]');
    if (open) {
      event.preventDefault();
      var d = dialogFor(open);
      if (!d) return;
      if (typeof d.showModal === 'function') d.showModal();
      else d.setAttribute('open', '');
      return;
    }

    var close = event.target.closest('[data-sizeguide-close]');
    if (close) {
      event.preventDefault();
      var dc = close.closest('[data-sizeguide]');
      if (!dc) return;
      if (typeof dc.close === 'function') dc.close();
      else dc.removeAttribute('open');
      return;
    }

    // Clicking the backdrop closes; clicking the panel does not.
    var dlg = event.target.closest('[data-sizeguide]');
    if (dlg && event.target === dlg) {
      if (typeof dlg.close === 'function') dlg.close();
      else dlg.removeAttribute('open');
    }
  });
})();
